import { render, staticRenderFns } from "./CustomersDetails.vue?vue&type=template&id=8f220b0a&scoped=true"
import script from "./CustomersDetails.vue?vue&type=script&lang=js"
export * from "./CustomersDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomersDetails.vue?vue&type=style&index=0&id=8f220b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f220b0a",
  null
  
)

export default component.exports